module.exports = __webpack_public_path__ + "img/logo.bb7334bc.png";